<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="headingSchuldigerkenningen1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseSchuldigerkenningen1" aria-expanded="false"
                    aria-controls="collapseSchuldigerkenningen1">
                Schenking op papier (schuldigerkenningen)
            </button>
        </h2>
        <div id="collapseSchuldigerkenningen1" class="accordion-collapse collapse"
             aria-labelledby="headingSchuldigerkenningen1">
            <div class="accordion-body">
                De 'Schenking op papier' bevat de gegevens over de schenking, in het geval dat het een schenking op
                papier, ook wel genoemd schuldigerkenning uit vrijgevigheid, betreft.
                <div class="space20"></div>
                Bij een schuldigerkenning uit vrijgevigheid wordt een bedrag schuldig gebleven in plaats van direct
                overgedragen. Deze constructie wordt vaak toegepast bij schenkingen aan kinderen, met name bij
                woningfinanciering. De vordering van het kind wordt verhoogd, zonder feitelijke betaling door de ouder.
                De schenking is belast op het moment van het tekenen van de akte.
                <div class="space20"></div>
                Het is gebruikelijk dat een rente wordt bedongen om te voorkomen dat het rentevoordeel ook als
                aanvullende schenking wordt aangemerkt. Zonder rente ontstaat er jaarlijks een fictieve schenking van
                het rentevoordeel.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="headingSchuldigerkenningen2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseSchuldigerkenningen2" aria-expanded="false"
                    aria-controls="collapseSchuldigerkenningen2">
                Rentepercentage
            </button>
        </h2>
        <div id="collapseSchuldigerkenningen2" class="accordion-collapse collapse"
             aria-labelledby="headingSchuldigerkenningen2">
            <div class="accordion-body">
                Het rentepercentage bij een schenking op papier is fiscaal relevant. Als er geen of een te lage rente
                wordt afgesproken, ontstaat er jaarlijks een fictieve schenking ter waarde van het rentevoordeel.
                <div class="space20"></div>
                Voor de Belastingdienst wordt doorgaans een rente van minimaal 6% als zakelijk beschouwd. Een lagere
                rente kan leiden tot extra schenkbelasting over het rentevoordeel.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="headingRenteSoort">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseRenteSoort" aria-expanded="false"
                    aria-controls="collapseRenteSoort">
                Soort rente bij schenking op papier
            </button>
        </h2>
        <div id="collapseRenteSoort" class="accordion-collapse collapse"
             aria-labelledby="headingRenteSoort">
            <div class="accordion-body">
                De 'soort rente schenking op papier' geeft aan welke rentevorm wordt toegepast. Dit kan invloed hebben
                op de uiteindelijke omvang van de schuld en de fiscale gevolgen.
                <div class="space20"></div>
                <ul>
                    <li><strong>Enkelvoudige rente (ER):</strong> De rente wordt alleen berekend over het
                        oorspronkelijke schenkingsbedrag. Er is geen sprake van rente-op-rente.
                    </li>
                    <li><strong>Samengestelde rente (SR):</strong> De rente wordt berekend over het oorspronkelijke
                        bedrag én eerder bijgeschreven rente. Dit leidt tot een snellere groei van de schuld.
                    </li>
                </ul>
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="headingOpeisbaarheid">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapseOpeisbaarheid" aria-expanded="false"
                    aria-controls="collapseOpeisbaarheid">
                Datum opeisbaarheid
            </button>
        </h2>
        <div id="collapseOpeisbaarheid" class="accordion-collapse collapse"
             aria-labelledby="headingOpeisbaarheid">
            <div class="accordion-body">
                De datum van opeisbaarheid bepaalt vanaf welk moment de schenking op papier daadwerkelijk opgeëist kan
                worden door de begiftigde.
                <div class="space20"></div>
                In veel gevallen wordt deze datum gekoppeld aan het overlijden van de schenker. Dit betekent dat de
                schuld pas opeisbaar is bij het overlijden, en tot die tijd blijft bestaan als een rentedragende schuld
                op papier. <br/>
                <b>Let op!</b> Je hoeft in dit geval geen datum in te vullen in het aangifteprogramma.
                <div class="space20"></div>
                Het is belangrijk dat deze bepaling duidelijk in de schenkingsakte wordt vastgelegd, omdat het invloed
                heeft op de fiscale behandeling en de nalatenschap.
            </div>
        </div>
    </div>


</div>
